import React, { Component } from 'react'
import { ToastContainer } from 'react-toastify'
import { Footer } from 'components/footer'
import { DialogsContainer } from 'pages/dialogs'

export class LayoutBase extends Component {
  renderContent () { return null } // to be overridden
  render () {
    return (
      <React.Fragment>
        {this.renderContent()}
        <Footer />
        <DialogsContainer />
        <ToastContainer autoClose={2000} />
      </React.Fragment>
    )
  }
}

export default LayoutBase
